// public/v3/src/lib/all-lens-metrics.js
// Per-program met/total counts for the All-lens "Met target" stat.
//
// Two rules make the split stat honest (previously it showed e.g. "51 BHI of
// 51" on a 36-patient BHI panel):
//   1. Enrollment decides membership, not target > 0 — adaptPatient computes
//      a BHI target for every patient (resolveBhiBillCode has an answer
//      whether or not the patient is enrolled) and a default 20-minute CCM
//      target even for BHI-only patients, so target-based counting inflates
//      both columns to the whole union roster.
//   2. Each program is measured against ITS OWN minutes — `logged` in the All
//      lens is the combined CCM+BHI total, so comparing it to a per-program
//      target would let one program's minutes satisfy the other's gate (the
//      same basis-mismatch class as the dual CCM+BHI push bug).
//
// targetFn(patient, slot) is targetForRow from time-logs-bhi-predicate.js;
// admitFn(patient, slot) is operationalForFilter from the same module.
// `logged` is the page's per-patient minute map (combined in the All lens);
// `bhiLogged` is the always-BHI-minutes map the page maintains for the
// per-row split display — CCM minutes are recovered as the difference.

function metCountsByProgram(operationalPatients, logged, bhiLogged, targetFn, admitFn) {
  let ccmMet = 0, ccmTotal = 0, bhiMet = 0, bhiTotal = 0;
  for (const p of operationalPatients) {
    const total = Number((logged && logged[p.id]) ?? p.logged ?? 0);
    const bhiMins = Number((bhiLogged && bhiLogged[p.id]) || 0);
    const ccmMins = Math.max(0, total - bhiMins);
    if (admitFn(p, 'ccm')) {
      const t = targetFn(p, 'ccm');
      if (t > 0) {
        ccmTotal++;
        if (ccmMins >= t) ccmMet++;
      }
    }
    if (admitFn(p, 'bhi')) {
      const t = targetFn(p, 'bhi');
      if (t > 0) {
        bhiTotal++;
        if (bhiMins >= t) bhiMet++;
      }
    }
  }
  return { ccmMet, ccmTotal, bhiMet, bhiTotal };
}

module.exports = { metCountsByProgram };
